pathClean